import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient, ApiError } from '@utils';

interface ResetPasswordPayload {
  password: string;
  passwordConfirmation: string;
  resetToken: string;
}

export const useResetPassword = (callback: () => void) => {
  return useMutation<void, ApiError, ResetPasswordPayload>({
    mutationFn: async (values: ResetPasswordPayload) => {
      const result = await apiClient.user.resetPassword.mutation({ body: values });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      toast.success('Password updated successfully. You can now log in.');
      callback();
    },
    onError: (error) => {
      showErrorToast(error, `Reset password failed!`);
    },
  });
};
